import { render, staticRenderFns } from "./KnBackToTopButton.vue?vue&type=template&id=7007f561&"
import script from "./KnBackToTopButton.vue?vue&type=script&lang=js&"
export * from "./KnBackToTopButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports